/* ============================================================
   ARWO - Merkliste und Model/Produkt-Umschalter

   Eigene Datei, nicht in theme.js: theme.js ist ueber 60 KB gross und
   muss bei jeder Aenderung komplett neu hochgeladen werden. Diese
   Funktion ist in sich geschlossen und wird erfahrungsgemaess oefter
   nachgebessert - hier kostet das wenig. Die zugehoerigen Stile stehen
   aus demselben Grund in assets/merken.css.

   Gemeinsame Teile kommen ueber window.ACIDTheme aus theme.js
   (formatMoney). Das Oeffnen der Schublade uebernimmt weiterhin der
   Overlay-Mechanismus in theme.js ueber data-overlay-open.
   ============================================================ */
(function () {
  'use strict';

  var ACID = window.ACID || {};

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var theme = window.ACIDTheme;
    if (theme && theme.formatMoney) return theme.formatMoney(cents);
    // Rueckfall, falls theme.js einmal nicht geladen hat.
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ---------- Umschalter Model / Produkt ----------
     Schaltet die Produktgalerie zwischen Modelaufnahmen und Freistellern.
     Versteckt wird per CSS ueber data-medien am Galerierahmen, nicht per
     JS an jedem einzelnen Bild: so bleibt auch der Punktestreifen ohne
     Zusatzarbeit im Gleichklang, und beim Zurueckschalten muss nichts
     wiederhergestellt werden. */

  function initProductMediaToggle() {
    var rahmen = $('[data-medien]');
    var tabs = $$('[data-medien-tab]');
    if (!rahmen || !tabs.length) return;
    var bahn = $('[data-gallery-track]', rahmen);

    tabs.forEach(function (tab) {
      if (tab.dataset.bereit === '1') return;
      tab.dataset.bereit = '1';

      tab.addEventListener('click', function () {
        var gruppe = tab.getAttribute('data-medien-tab');
        if (rahmen.getAttribute('data-medien') === gruppe) return;
        rahmen.setAttribute('data-medien', gruppe);

        tabs.forEach(function (anderer) {
          var an = anderer === tab;
          anderer.classList.toggle('is-on', an);
          anderer.setAttribute('aria-pressed', an ? 'true' : 'false');
        });

        // Ohne Sprung an den Anfang bliebe die Bahn auf der Scrollposition
        // der alten Gruppe stehen - und damit auf einem leeren Bereich.
        if (bahn) bahn.scrollTo({ left: 0, behavior: 'auto' });
        rahmen.dispatchEvent(new CustomEvent('acid:gallery:refresh'));
      });
    });
  }

  /* ---------- Merkliste ----------
     Gespeichert wird im Browser des Besuchers (localStorage), nicht am
     Kundenkonto: ohne Login gibt es nichts, woran eine Liste sonst haengen
     koennte. Dafuer funktioniert sie ohne Anmeldung und ohne Fremd-App -
     sie gilt dann aber pro Geraet, und genau das steht auch in der
     Schublade.

     Gemerkt werden nur die Handles. Titel, Preis und Bild holt die
     Schublade beim Oeffnen frisch ueber /products/<handle>.js, damit nach
     einer Preisaenderung nicht der alte Preis aus dem Speicher auftaucht. */

  var Merkliste = {
    SCHLUESSEL: 'arwo-merkliste',

    lies: function () {
      try {
        var roh = localStorage.getItem(this.SCHLUESSEL);
        var liste = roh ? JSON.parse(roh) : [];
        if (!Array.isArray(liste)) return [];
        return liste.filter(function (h) { return typeof h === 'string' && h.length > 0; });
      } catch (e) {
        return [];
      }
    },

    schreib: function (liste) {
      try { localStorage.setItem(this.SCHLUESSEL, JSON.stringify(liste)); } catch (e) { /* egal */ }
    },

    hat: function (handle) { return this.lies().indexOf(handle) !== -1; },

    umschalten: function (handle) {
      var liste = this.lies();
      var stelle = liste.indexOf(handle);
      if (stelle === -1) liste.push(handle);
      else liste.splice(stelle, 1);
      this.schreib(liste);
      return liste;
    },

    entfernen: function (handle) {
      var liste = this.lies().filter(function (h) { return h !== handle; });
      this.schreib(liste);
      return liste;
    }
  };

  function initMerken() {
    function wort(drin) {
      var s = ACID.strings || {};
      if (drin) return s.remembered || 'GEMERKT';
      return s.remember || 'MERKEN';
    }

    function malen() {
      var liste = Merkliste.lies();
      var anzahl = liste.length;

      $$('[data-merk-anzahl]').forEach(function (el) {
        var span = el.querySelector('span');
        if (span) span.textContent = anzahl;
        el.hidden = anzahl === 0;
      });
      $$('[data-merk-anzahl-text]').forEach(function (el) {
        el.textContent = anzahl ? ' (' + anzahl + ')' : '';
      });

      $$('[data-merken]').forEach(function (knopf) {
        var drin = liste.indexOf(knopf.getAttribute('data-handle')) !== -1;
        knopf.classList.toggle('is-gemerkt', drin);
        knopf.setAttribute('aria-pressed', drin ? 'true' : 'false');
        var text = $('[data-merken-text]', knopf);
        if (text) text.textContent = wort(drin);
        else knopf.setAttribute('aria-label', wort(drin));
      });
    }

    function wurzel() {
      var r = window.Shopify && Shopify.routes && Shopify.routes.root;
      return r || '/';
    }

    function bildKlein(url) {
      if (!url) return '';
      // Shopifys CDN skaliert ueber den Parameter width. Die URL aus der
      // Produkt-JSON bringt schon ein ?v=... mit, deshalb mit & anhaengen.
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=300';
    }

    function zeileBauen(produkt) {
      var li = document.createElement('li');
      li.className = 'cart-item wishlist-item';

      var bild = produkt.featured_image || (produkt.images && produkt.images[0]) || '';
      var url = wurzel() + 'products/' + produkt.handle;
      var preis = formatMoney(produkt.price);
      var s = ACID.strings || {};

      // Bewusst OHNE loading="lazy": die Zeile entsteht erst beim Oeffnen
      // der Schublade, und der Browser hielt ein lazy-Bild darin fuer
      // ausserhalb des Blickfelds - es wurde nie geladen und die Zeile blieb
      // leer. Die Liste ist kurz, eager kostet hier nichts.
      li.innerHTML =
        '<a class="cart-item__media media" href="' + url + '">' +
        (bild ? '<img src="' + bildKlein(bild) + '" alt="" width="84" height="105">' : '') +
        '</a>' +
        '<div class="cart-item__details">' +
        '<a class="cart-item__title" href="' + url + '"></a>' +
        '<span class="cart-item__price">' + preis + '</span>' +
        '<div class="cart-item__row">' +
        '<a class="link-underline" href="' + url + '">' + (s.view || 'ANSEHEN') + '</a>' +
        '<button type="button" class="cart-item__remove" data-merk-weg>' + (s.wishRemove || 'Entfernen') + '</button>' +
        '</div></div>';

      // Titel bewusst ueber textContent, nicht im HTML-Baustein oben:
      // Produkttitel duerfen Zeichen enthalten, die als Markup gelesen
      // wuerden.
      li.querySelector('.cart-item__title').textContent = produkt.title;
      li.querySelector('[data-merk-weg]').setAttribute('data-merk-weg', produkt.handle);
      return li;
    }

    // Zaehlt jeden Fuell-Durchlauf mit. Noetig, weil das Fuellen zweimal
    // kurz hintereinander angestossen werden kann (einmal beim Merken,
    // einmal beim Oeffnen der Schublade). Ohne diese Nummer haengten beide
    // Durchlaeufe ihr Ergebnis an - aus einem gemerkten Teil wurden zwei
    // Zeilen. Jetzt gewinnt der jeweils neueste, der aeltere verwirft sich.
    var fuellLauf = 0;

    function schubladeFuellen() {
      var liste = $('[data-merk-liste]');
      var leer = $('[data-merk-leer]');
      var fuss = $('[data-merk-fuss]');
      if (!liste) return;

      var handles = Merkliste.lies();
      var lauf = ++fuellLauf;

      function zeigeLeer() {
        liste.innerHTML = '';
        liste.hidden = true;
        if (leer) leer.hidden = false;
        if (fuss) fuss.hidden = true;
      }

      if (!handles.length) { zeigeLeer(); return; }

      if (leer) leer.hidden = true;
      liste.hidden = false;
      if (fuss) fuss.hidden = false;

      // Erst alles holen, dann in einem Rutsch zeichnen. Nebenbei bleibt so
      // die Reihenfolge erhalten - bei einzeln angehaengten Zeilen haette
      // entschieden, welche Antwort zufaellig zuerst da war.
      Promise.all(handles.map(function (handle) {
        return fetch(wurzel() + 'products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) {
            if (!r.ok) throw new Error('weg');
            return r.json();
          })
          .catch(function () {
            // Produkt gibt es nicht mehr (geloescht oder umbenannt): still
            // aus der Liste nehmen, statt eine tote Zeile zu zeigen.
            Merkliste.entfernen(handle);
            return null;
          });
      })).then(function (produkte) {
        if (lauf !== fuellLauf) return;

        var gefunden = produkte.filter(function (p) { return p; });
        if (!gefunden.length) { zeigeLeer(); malen(); return; }

        liste.innerHTML = '';
        gefunden.forEach(function (p) { liste.appendChild(zeileBauen(p)); });
        malen();
      });
    }

    // Ein einziger Zuhoerer am Dokument statt einer pro Knopf: die
    // Schubladeneintraege entstehen erst beim Oeffnen, ein Zuhoerer je
    // Knopf haette sie nie erwischt.
    if (!document.body.dataset.merkenBereit) {
      document.body.dataset.merkenBereit = '1';

      document.addEventListener('click', function (e) {
        var knopf = e.target.closest('[data-merken]');
        if (knopf) {
          e.preventDefault();
          Merkliste.umschalten(knopf.getAttribute('data-handle'));
          malen();
          schubladeFuellen();
          return;
        }

        var weg = e.target.closest('[data-merk-weg]');
        if (weg) {
          e.preventDefault();
          Merkliste.entfernen(weg.getAttribute('data-merk-weg'));
          malen();
          schubladeFuellen();
        }
      });

      // Beim Oeffnen neu laden, damit Preise und Titel aktuell sind.
      document.addEventListener('acid:overlay:open', function (e) {
        if (e.detail && e.detail.element && e.detail.element.id === 'WishlistDrawer') schubladeFuellen();
      });
    }

    malen();
  }

  function start() {
    initProductMediaToggle();
    initMerken();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // Im Theme-Editor werden Abschnitte neu gezeichnet - danach sind die
  // Knoepfe neu im Dokument und brauchen ihren Zustand zurueck.
  document.addEventListener('shopify:section:load', start);
})();
